<template>
  <div class="db-tag-filter">
    <slot />
    <button
      type="button"
      class="db-tag-filter-button"
      v-on:click="$emit('delete')"
    >
      <!-- slot is duplicated to have an explicit label for AT -->
      <span class="db-visually-hidden">{{ $t('Delete') }} <slot /></span>
      <IconDbClose
        width="8"
        height="8"
      />
    </button>
  </div>
</template>

<style scoped>
/* Tag filters */
.db-app .db-tag-filter {
  display: inline-flex;
  align-items: center;
  gap: var(--db-spacer-8);
  min-height: var(--db-spacer-36);
  padding-left: var(--db-spacer-8);
  font-family: var(--db_body_text_font_family);
  font-size: var(--db_small_body_text_font_size);
  color: var(--db_box_body_text_color);
  background-color: var(--db_box_background_color);
  border: 1px solid var(--db_box_borders_color);
  border-radius: 4px;
  word-break: break-word;
}

.db-app .db-tag-filter .db-icon {
  fill: var(--db_box_body_text_color);
}

.db-app .db-tag-filter > * {
  flex-shrink: 0;
}

.db-app .db-tag-filter .db-tag-filter-button {
  line-height: 1;
  cursor: pointer;
  padding: var(--db-spacer-8);
}
</style>
